var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilePlanHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "426px",
    height: "426px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.542
    },
    fill: "#020202",
    d: "M 263.5,34.5 C 263.167,34.5 262.833,34.5 262.5,34.5C 261.833,34.1667 261.167,33.8333 260.5,33.5C 259.327,31.4959 257.66,29.9959 255.5,29C 251.244,28.3478 247.244,28.8478 243.5,30.5C 240.43,30.3677 237.43,30.701 234.5,31.5C 234.5,31.1667 234.5,30.8333 234.5,30.5C 242.296,27.2362 250.296,26.4029 258.5,28C 260.765,29.7581 262.432,31.9248 263.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.872
    },
    fill: "#fdfdfd",
    d: "M 232.5,30.5 C 207.052,36.9436 181.385,42.9436 155.5,48.5C 179.798,37.01 205.465,31.01 232.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#fcfcfc",
    d: "M 243.5,30.5 C 249.175,31.4062 254.842,32.4062 260.5,33.5C 261.167,33.8333 261.833,34.1667 262.5,34.5C 285.541,136.664 309.208,238.664 333.5,340.5C 334.076,344.112 333.076,347.112 330.5,349.5C 329.508,349.328 328.842,349.662 328.5,350.5C 327.833,350.5 327.5,350.833 327.5,351.5C 326.508,351.328 325.842,351.662 325.5,352.5C 323.299,353.566 320.965,354.233 318.5,354.5C 273.533,365.061 228.533,375.561 183.5,386C 177.475,387.621 172.475,386.121 168.5,381.5C 148.101,291.245 127.101,201.245 105.5,111.5C 105.5,110.833 105.5,110.167 105.5,109.5C 107.551,106.342 109.217,103.008 110.5,99.5C 131.949,189.302 153.115,279.302 174,369.5C 174.2,371.32 175.034,372.653 176.5,373.5C 175.376,369.214 174.376,364.881 173.5,360.5C 173.818,359.353 174.484,358.519 175.5,358C 223.5,346.767 271.5,335.601 319.5,324.5C 320.417,329.004 321.417,333.504 322.5,338C 322.072,342.539 319.739,345.539 315.5,347C 271.116,357.18 226.783,367.513 182.5,378C 184.5,378.667 186.5,378.667 188.5,378C 232.689,367.952 276.689,357.286 320.5,346C 323.999,340.493 324.499,334.659 322,328.5C 302.173,244.193 282.506,159.86 263,75.5C 260.604,64.9012 257.77,54.5679 254.5,44.5C 254.167,42.1667 252.833,40.8333 250.5,40.5C 249.223,39.1024 247.557,38.4357 245.5,38.5C 232.611,41.2639 219.778,44.2639 207,47.5C 206.5,47.1667 206,46.8333 205.5,46.5C 206.58,43.6682 207.58,40.8349 208.5,38C 217.281,36.1382 225.947,33.9715 234.5,31.5C 237.43,30.701 240.43,30.3677 243.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#fefefe",
    d: "M 263.5,34.5 C 286.757,41.1276 307.757,51.961 326.5,67C 354.491,90.8304 376.324,119.33 392,152.5C 400.899,175.022 403.899,198.356 401,222.5C 397.865,258.251 385.865,290.584 365,319.5C 356.167,329.841 346.001,338.507 334.5,345.5C 334.5,343.833 334.5,342.167 334.5,340.5C 310.832,238.495 287.165,136.495 263.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#fbfcfc",
    d: "M 250.5,40.5 C 251.5,42.1667 252.833,43.5 254.5,44.5C 254.62,47.4802 255.287,50.3135 256.5,53C 209.242,64.4849 161.909,75.6516 114.5,86.5C 115.915,79.6694 118.915,73.6694 123.5,68.5C 124.391,67.8902 125.391,67.5569 126.5,67.5C 164.155,58.7347 201.822,49.9014 239.5,41C 243.152,40.5014 246.818,40.3347 250.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#545353",
    d: "M 250.5,40.5 C 252.833,40.8333 254.167,42.1667 254.5,44.5C 252.833,43.5 251.5,42.1667 250.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656464",
    d: "M 229.5,56.5 C 233.553,55.9873 237.553,55.154 241.5,54C 243.363,52.5822 243.863,50.7489 243,48.5C 242.439,47.9781 241.772,47.6448 241,47.5C 236.802,48.4389 232.636,49.4389 228.5,50.5C 228.611,49.8826 228.944,49.3826 229.5,49C 233.132,48.0086 236.799,47.1752 240.5,46.5C 247.086,47.343 248.086,50.1763 243.5,55C 239.649,55.7544 235.816,56.5877 232,57.5C 230.93,57.472 230.097,57.1386 229.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfe8ec",
    d: "M 229.5,56.5 C 229.483,54.4352 229.15,52.4352 228.5,50.5C 232.636,49.4389 236.802,48.4389 241,47.5C 241.772,47.6448 242.439,47.9781 243,48.5C 243.863,50.7489 243.363,52.5822 241.5,54C 237.553,55.154 233.553,55.9873 229.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.913
    },
    fill: "#fafafa",
    d: "M 147.5,53.5 C 149.144,55.4807 150.81,57.4807 152.5,59.5C 144.283,61.9708 135.95,63.9708 127.5,65.5C 131.593,61.0706 136.259,57.404 141.5,54.5C 142.167,54.5 142.5,54.1667 142.5,53.5C 144.234,52.438 145.901,52.438 147.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6a6a",
    d: "M 228.5,50.5 C 229.15,52.4352 229.483,54.4352 229.5,56.5C 227.539,54.68 227.206,52.68 228.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 111.5,96.5 C 111.5,95.1667 111.5,93.8333 111.5,92.5C 112.345,91.3285 113.011,89.9952 113.5,88.5C 159.445,77.6095 205.445,66.7762 251.5,56C 253.441,55.2571 255.274,55.4238 257,56.5C 277.978,145.412 298.478,234.412 318.5,323.5C 269.888,334.445 221.388,345.778 173,357.5C 152.622,270.328 132.122,183.328 111.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6a",
    d: "M 232.5,30.5 C 233.167,30.5 233.833,30.5 234.5,30.5C 234.5,30.8333 234.5,31.1667 234.5,31.5C 225.947,33.9715 217.281,36.1382 208.5,38C 207.58,40.8349 206.58,43.6682 205.5,46.5C 206,46.8333 206.5,47.1667 207,47.5C 219.778,44.2639 232.611,41.2639 245.5,38.5C 247.557,38.4357 249.223,39.1024 250.5,40.5C 246.818,40.3347 243.152,40.5014 239.5,41C 201.822,49.9014 164.155,58.7347 126.5,67.5C 126.5,66.8333 126.5,66.1667 126.5,65.5C 126.833,65.5 127.167,65.5 127.5,65.5C 135.95,63.9708 144.283,61.9708 152.5,59.5C 150.81,57.4807 149.144,55.4807 147.5,53.5C 147.328,52.5084 147.662,51.8417 148.5,51.5C 150.108,54.9435 152.608,57.6102 156,59.5C 171.808,55.5898 187.641,51.7565 203.5,48C 204.645,44.8776 205.645,41.7109 206.5,38.5C 187.829,42.834 169.162,47.1674 150.5,51.5C 150.833,50.8333 151.167,50.1667 151.5,49.5C 152.833,49.1667 154.167,48.8333 155.5,48.5C 181.385,42.9436 207.052,36.9436 232.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f5f6",
    d: "M 148.5,51.5 C 149.167,51.5 149.833,51.5 150.5,51.5C 169.162,47.1674 187.829,42.834 206.5,38.5C 205.645,41.7109 204.645,44.8776 203.5,48C 187.641,51.7565 171.808,55.5898 156,59.5C 152.608,57.6102 150.108,54.9435 148.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cedde4",
    d: "M 104.5,111.5 C 125.236,201.769 146.569,291.769 168.5,381.5C 170.362,385.777 173.695,388.111 178.5,388.5C 177.432,389.434 176.099,389.768 174.5,389.5C 170.917,388.614 167.25,387.614 163.5,386.5C 161.5,386.5 160.5,385.5 160.5,383.5C 140.738,296.248 120.405,209.248 99.5,122.5C 96.3164,107.444 92.8164,92.4441 89,77.5C 88.4763,69.7059 91.9763,65.2059 99.5,64C 98.2986,64.9025 97.4652,66.0692 97,67.5C 96.3333,70.8333 96.3333,74.1667 97,77.5C 99.397,88.8939 101.897,100.227 104.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.549
    },
    fill: "#000000",
    d: "M 126.5,65.5 C 126.5,66.1667 126.5,66.8333 126.5,67.5C 125.391,67.5569 124.391,67.8902 123.5,68.5C 110.421,69.0125 106.087,75.3459 110.5,87.5C 111.417,86.8728 112.417,86.5394 113.5,86.5C 113.5,87.1667 113.5,87.8333 113.5,88.5C 110.664,88.8373 109.998,90.1707 111.5,92.5C 111.5,93.8333 111.5,95.1667 111.5,96.5C 111.5,97.1667 111.167,97.5 110.5,97.5C 108.043,90.3466 106.876,83.0132 107,75.5C 107.707,73.9194 108.54,72.4194 109.5,71C 114.97,68.4757 120.636,66.6423 126.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727271",
    d: "M 254.5,44.5 C 257.77,54.5679 260.604,64.9012 263,75.5C 282.506,159.86 302.173,244.193 322,328.5C 324.499,334.659 323.999,340.493 320.5,346C 276.689,357.286 232.689,367.952 188.5,378C 186.5,378.667 184.5,378.667 182.5,378C 226.783,367.513 271.116,357.18 315.5,347C 319.739,345.539 322.072,342.539 322.5,338C 321.417,333.504 320.417,329.004 319.5,324.5C 271.5,335.601 223.5,346.767 175.5,358C 174.484,358.519 173.818,359.353 173.5,360.5C 174.376,364.881 175.376,369.214 176.5,373.5C 175.034,372.653 174.2,371.32 174,369.5C 153.115,279.302 131.949,189.302 110.5,99.5C 110.5,98.8333 110.5,98.1667 110.5,97.5C 111.167,97.5 111.5,97.1667 111.5,96.5C 132.122,183.328 152.622,270.328 173,357.5C 221.388,345.778 269.888,334.445 318.5,323.5C 298.478,234.412 277.978,145.412 257,56.5C 255.274,55.4238 253.441,55.2571 251.5,56C 205.445,66.7762 159.445,77.6095 113.5,88.5C 113.5,87.8333 113.5,87.1667 113.5,86.5C 113.833,86.5 114.167,86.5 114.5,86.5C 161.909,75.6516 209.242,64.4849 256.5,53C 255.287,50.3135 254.62,47.4802 254.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747373",
    d: "M 262.5,34.5 C 262.833,34.5 263.167,34.5 263.5,34.5C 287.165,136.495 310.832,238.495 334.5,340.5C 334.167,340.5 333.833,340.5 333.5,340.5C 309.208,238.664 285.541,136.664 262.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#1b1b1b",
    d: "M 151.5,49.5 C 151.167,50.1667 150.833,50.8333 150.5,51.5C 149.833,51.5 149.167,51.5 148.5,51.5C 147.662,51.8417 147.328,52.5084 147.5,53.5C 145.901,52.438 144.234,52.438 142.5,53.5C 141.833,53.5 141.5,53.8333 141.5,54.5C 129.755,56.5493 118.088,59.0493 106.5,62C 98.9135,64.0025 96.0801,68.8358 98,76.5C 100.662,87.4784 103.162,98.4784 105.5,109.5C 105.5,110.167 105.5,110.833 105.5,111.5C 105.167,111.5 104.833,111.5 104.5,111.5C 101.897,100.227 99.397,88.8939 97,77.5C 96.3333,74.1667 96.3333,70.8333 97,67.5C 97.4652,66.0692 98.2986,64.9025 99.5,64C 91.9763,65.2059 88.4763,69.7059 89,77.5C 92.8164,92.4441 96.3164,107.444 99.5,122.5C 99.1667,122.5 98.8333,122.5 98.5,122.5C 98.6716,121.508 98.3382,120.842 97.5,120.5C 94.6527,106.443 91.4861,92.4429 88,78.5C 86.5717,69.9182 90.0717,64.4182 98.5,62C 116.171,57.7665 133.837,53.5999 151.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.513
    },
    fill: "#000000",
    d: "M 73.5,112.5 C 74.4972,112.47 75.1639,112.97 75.5,114C 74.9221,115.811 74.4221,117.645 74,119.5C 73.5,119 73,118.5 72.5,118C 73.4061,116.301 73.7394,114.467 73.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.501
    },
    fill: "#000000",
    d: "M 65.5,119.5 C 67.9892,119.298 70.3225,119.798 72.5,121C 71.3333,121.167 70.1667,121.333 69,121.5C 67.3189,121.392 66.1522,120.725 65.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.512
    },
    fill: "#000000",
    d: "M 74.5,120.5 C 76.9892,120.298 79.3225,120.798 81.5,122C 80.3333,122.167 79.1667,122.333 78,122.5C 76.3189,122.392 75.1522,121.725 74.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#fefefe",
    d: "M 97.5,120.5 C 98.3382,120.842 98.6716,121.508 98.5,122.5C 118.678,209.749 139.345,296.749 160.5,383.5C 160.5,385.5 161.5,386.5 163.5,386.5C 164.347,387.966 165.68,388.8 167.5,389C 169.81,389.497 172.143,389.663 174.5,389.5C 176.099,389.768 177.432,389.434 178.5,388.5C 225.097,377.517 271.763,366.851 318.5,356.5C 269.285,388.377 215.619,399.877 157.5,391C 119.334,383.512 87.5003,365.346 62,336.5C 32.6447,295.413 20.6447,249.746 26,199.5C 27.1312,195.106 28.4646,190.773 30,186.5C 36.8166,173.53 45.3166,161.864 55.5,151.5C 55.5216,153.8 56.5216,154.967 58.5,155C 56.913,152.135 57.5797,149.968 60.5,148.5C 62.9783,149.722 63.9783,151.722 63.5,154.5C 65.5244,150.377 64.1911,148.044 59.5,147.5C 61.2368,145.45 63.2368,143.617 65.5,142C 76.7128,135.567 87.3795,128.4 97.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.512
    },
    fill: "#000000",
    d: "M 72.5,122.5 C 73.2891,122.783 73.9558,123.283 74.5,124C 73.8971,125.825 73.2304,127.659 72.5,129.5C 71.6365,127.229 71.6365,124.895 72.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6db435",
    d: "M 252.5,144.5 C 254.48,145.848 255.647,147.848 256,150.5C 261.835,176.181 267.668,201.848 273.5,227.5C 268.534,228.627 263.534,229.627 258.5,230.5C 252.027,202.94 246.027,175.274 240.5,147.5C 244.761,147.102 248.761,146.102 252.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595958",
    d: "M 59.5,147.5 C 64.1911,148.044 65.5244,150.377 63.5,154.5C 63.9783,151.722 62.9783,149.722 60.5,148.5C 57.5797,149.968 56.913,152.135 58.5,155C 56.5216,154.967 55.5216,153.8 55.5,151.5C 55.8333,149.167 57.1667,147.833 59.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0a0a0",
    d: "M 83.5,150.5 C 88.1585,150.015 89.4919,151.848 87.5,156C 82.7282,156.81 81.3948,154.977 83.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#555454",
    d: "M 63.5,154.5 C 62.6857,156.273 61.3524,156.773 59.5,156C 60.745,155.209 62.0783,154.709 63.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6db435",
    d: "M 229.5,156.5 C 230.822,156.33 231.989,156.663 233,157.5C 238.29,182.493 244.124,207.326 250.5,232C 245.391,234.081 240.224,234.915 235,234.5C 229.794,209.675 223.96,185.008 217.5,160.5C 221.376,158.537 225.376,157.204 229.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eb436",
    d: "M 205.5,173.5 C 207.833,173.5 210.167,173.5 212.5,173.5C 217.326,195.136 221.992,216.802 226.5,238.5C 221.428,239.178 216.428,240.178 211.5,241.5C 206.833,219.5 202.167,197.5 197.5,175.5C 200.428,175.435 203.095,174.768 205.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6db435",
    d: "M 189.5,197.5 C 190.822,197.33 191.989,197.663 193,198.5C 196.347,213.555 199.847,228.555 203.5,243.5C 199.288,244.261 195.121,245.261 191,246.5C 189.674,246.245 188.674,245.578 188,244.5C 184.941,230.477 181.774,216.477 178.5,202.5C 178.608,201.558 178.941,200.725 179.5,200C 182.991,199.262 186.325,198.429 189.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eb436",
    d: "M 168.5,216.5 C 170.144,216.286 171.644,216.62 173,217.5C 175.492,228.12 177.658,238.787 179.5,249.5C 174.871,250.02 170.371,251.02 166,252.5C 162.773,241.757 159.939,230.924 157.5,220C 161.34,219.041 165.007,217.875 168.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595a5a",
    d: "M 104.5,111.5 C 104.833,111.5 105.167,111.5 105.5,111.5C 127.101,201.245 148.101,291.245 168.5,381.5C 146.569,291.769 125.236,201.769 104.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6d6e",
    d: "M 98.5,122.5 C 98.8333,122.5 99.1667,122.5 99.5,122.5C 120.405,209.248 140.738,296.248 160.5,383.5C 139.345,296.749 118.678,209.749 98.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.512
    },
    fill: "#090909",
    d: "M 333.5,340.5 C 333.833,340.5 334.167,340.5 334.5,340.5C 334.5,342.167 334.5,343.833 334.5,345.5C 334.219,347.963 333.219,350.13 331.5,352C 327.813,354.285 323.813,355.452 319.5,355.5C 318.833,355.5 318.5,355.167 318.5,354.5C 320.965,354.233 323.299,353.566 325.5,352.5C 326.492,352.672 327.158,352.338 327.5,351.5C 328.167,351.5 328.5,351.167 328.5,350.5C 329.492,350.672 330.158,350.338 330.5,349.5C 333.076,347.112 334.076,344.112 333.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3e2e9",
    d: "M 220.5,351.5 C 221.496,351.414 222.329,351.748 223,352.5C 223.436,354.847 223.936,357.181 224.5,359.5C 224.182,360.647 223.516,361.481 222.5,362C 219.883,362.822 217.216,363.322 214.5,363.5C 214.089,360.447 213.423,357.447 212.5,354.5C 215.37,353.743 218.036,352.743 220.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#595958",
    d: "M 176.5,373.5 C 178.138,374.657 179.804,375.824 181.5,377C 178.808,377.319 177.142,376.153 176.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#696968",
    d: "M 318.5,354.5 C 318.5,355.167 318.833,355.5 319.5,355.5C 319.5,356.167 319.167,356.5 318.5,356.5C 271.763,366.851 225.097,377.517 178.5,388.5C 173.695,388.111 170.362,385.777 168.5,381.5C 172.475,386.121 177.475,387.621 183.5,386C 228.533,375.561 273.533,365.061 318.5,354.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3e3f3e",
    d: "M 163.5,386.5 C 167.25,387.614 170.917,388.614 174.5,389.5C 172.143,389.663 169.81,389.497 167.5,389C 165.68,388.8 164.347,387.966 163.5,386.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePlanHover);
export default __webpack_public_path__ + "static/media/mobile-plan-hover.bdcdb54861e25813d4c6f5f68dcef1ff.svg";
export { ForwardRef as ReactComponent };